import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { isAuthenticated, isSessionExpiredActive } from './directOAuthHandler';

interface LoginRequiredProps {
  title?: string;
  children: React.ReactNode;
}

const LoginRequired: React.FC<LoginRequiredProps> = ({ title, children }) => {
  const navigate = useNavigate();
  const authenticated = isAuthenticated();

  React.useEffect(() => {

    if (!authenticated && !window.location.search.includes('code=') && !isSessionExpiredActive()) {

      navigate('/login', { replace: true });
    }
  }, [authenticated, navigate]);

  if (!authenticated && !window.location.search.includes('code=') && !isSessionExpiredActive()) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column'
        }}
      >
        <CircularProgress size={60} />
        {title && (
          <Typography variant="h6" sx={{ mt: 2 }}>
            {title}
          </Typography>
        )}
      </Box>
    );
  }

  return <>{children}</>;
};

// HOC version
const requireLogin = (title?: string) => (WrappedComponent: React.ComponentType<any>) => {
  return (props: any) => (
    <LoginRequired title={title}>
      <WrappedComponent {...props} />
    </LoginRequired>
  );
};

export { LoginRequired };
export default requireLogin;

